import { MemberEdit } from 'ui/components/company/patterns/MemberEdit/MemberEdit';

/**
 * 売り手会社メンバー編集
 */
export const CompanyMemberEdit: React.FC = () => {
    return <MemberEdit />;
};
